/**
 * Leads perdidos — /crm/perdidos. Wrapper fino sobre LeadsListaTerminal
 * (tipo="perdidos"): mostra motivo + permite reativar (lead:perder).
 */
import React from "react";

import LeadsListaTerminal from "./LeadsListaTerminal";

function LeadsPerdidos() {
  return <LeadsListaTerminal tipo="perdidos" />;
}

export default LeadsPerdidos;
